import styled from 'styled-components';

export const TagContainer = styled.div`
  display: flex;
  gap: 0.75em;

  @media (max-width: ${(props) => props.theme.breakpoints.small}) {
    gap: 0.5em;
  }

  flex-wrap: wrap;
  max-width: 100%;
`;

export const LinkTag = styled.a<{ active?: boolean; color?: string, textColor?: string }>`
  color: ${(props) => props.textColor || 'var(--color-charcoal-v100)'};
  border-radius: 9999px;
  padding: 6px 12px;
  background-color: ${(props) => (props.color ? props.color : 'white')};
  font-weight: 600;
  white-space: pre;

  &:hover {
    color: inherit;
  }

  ${(props) => props.active && 'background-color: var(--color-bluescape-v40);'}
`;

export const Tag = styled(LinkTag).attrs({ as: 'span' })`
  &:hover {
    color: ${(props) => props.textColor || 'var(--color-charcoal-v100)'};
  }
`;

export const SmallTag = styled(Tag)`
  font-size: 12px;
  padding: 4px 8px;
  display: flex;
  gap: 4px;
  align-items: center;
`;
